import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito conocimientos de medicina?',
    a: 'No, está escrito para personas comunes con explicaciones paso a paso.'
  }, {
    q: '¿Sirve para perros también?',
    a: 'No, los gatos tienen una fisiología única y muchos medicamentos de perros son veneno para ellos. Esta es 100% felina.'
  }, {
    q: '¿Es un libro físico?',
    a: 'Es un PDF digital de descarga inmediata para que lo lleves siempre en el celular.'
  }, {
    q: '¿Qué pasa si mi gato ya está enfermo?',
    a: 'Compralo ahora y usá el Protocolo Semáforo para saber si tenés que salir corriendo a la guardia.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 px-4 bg-neutral-900" data-id="element-29">
      <div className="container mx-auto max-w-3xl" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-31">
          <h2 className="text-5xl font-display text-white mb-4" data-id="element-32">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-33">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-neutral-950 border border-neutral-800 rounded-2xl overflow-hidden" data-id="element-34">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-35">
                <span className="text-lg font-bold text-white" data-id="element-36">{faq.q}</span>
                <ChevronDown className={`text-brand transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-37" />
              </button>

              <AnimatePresence data-id="element-38">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-39">
                    <div className="px-6 pb-5 text-neutral-400 text-lg" data-id="element-40">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}